import { render, staticRenderFns } from "./login-journal.vue?vue&type=template&id=1dc6996c&scoped=true"
import script from "./login-journal.vue?vue&type=script&lang=js"
export * from "./login-journal.vue?vue&type=script&lang=js"
import style0 from "./login-journal.vue?vue&type=style&index=0&id=1dc6996c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc6996c",
  null
  
)

export default component.exports